// src/components/Header.js
import React, { useEffect, useState } from "react";

const Header = () => {
  const [outsideHero, setOutsideHero] = useState(false);
  const [active, setActive] = useState("hero");
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const hero = document.getElementById("hero");
    if (!hero) return;

    // Observe hero visibility to toggle header background
    const heroObserver = new IntersectionObserver(
      ([entry]) => {
        setOutsideHero(!entry.isIntersecting);
      },
      { root: null, threshold: 0.15 },
    );
    heroObserver.observe(hero);

    // Observe sections for active link
    const sections = Array.from(document.querySelectorAll("section[id]"));
    const sectionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) setActive(e.target.id);
        });
      },
      { root: null, threshold: 0.4 },
    );
    sections.forEach((s) => sectionObserver.observe(s));

    return () => {
      heroObserver.disconnect();
      sectionObserver.disconnect();
    };
  }, []);

  const handleLinkClick = () => {
    setMobileOpen(false);
  };

  return (
    <header
      id="header"
      className={`hero-header justify-content-between ${outsideHero ? "hero-header--outside-hero " : ""}`}
      role="banner"
    >
      <div className="hero-header__wrapper">
        <a href="#hero" className="hero-header__logo" onClick={handleLinkClick}>
          <img src="/assets/img/nav-hiro.png" alt="Originality" />
        </a>

        <nav className="hero-header__nav" aria-label="Main navigation">
          <button
            className="hero-header__toggle d-xl-none"
            aria-expanded={mobileOpen}
            aria-label="Toggle navigation"
            onClick={() => setMobileOpen((v) => !v)}
          >
            <i className="bi bi-list" />
          </button>

          <ul
            className={`hero-header__list ${mobileOpen ? "hero-header__list--open" : ""}`}
          >
            <li className="hero-header__item">
              <a
                href="#hero"
                className={`hero-header__link ${active === "hero" ? "hero-header__link--active" : ""}`}
                onClick={handleLinkClick}
              >
                Home
              </a>
            </li>
            <li className="hero-header__item">
              <a
                href="#about"
                className={`hero-header__link ${active === "about" ? "hero-header__link--active" : ""}`}
                onClick={handleLinkClick}
              >
                About
              </a>
            </li>
            <li className="hero-header__item">
              <a
                href="#special-deal"
                className={`hero-header__link ${active === "special-deal" ? "hero-header__link--active" : ""}`}
                onClick={handleLinkClick}
              >
                Special Deal
              </a>
            </li>
            <li className="hero-header__item">
              <a
                href="#our-brand"
                className={`hero-header__link ${active === "our-brand" ? "hero-header__link--active" : ""}`}
                onClick={handleLinkClick}
              >
                Our Brands
              </a>
            </li>
            <li className="hero-header__item">
              <a
                href="#our-products"
                className={`hero-header__link ${active === "our-products" ? "hero-header__link--active" : ""}`}
                onClick={handleLinkClick}
              >
                Our Products
              </a>
            </li>
            <li className="hero-header__item">
              <a
                href="#faq"
                className={`hero-header__link ${active === "faq" ? "hero-header__link--active" : ""}`}
                onClick={handleLinkClick}
              >
                FAQ
              </a>
            </li>
          </ul>

          <a
            href="https://wa.me/6281272800800"
            target="_blank"
            rel="noopener noreferrer"
            className="hero-header__cta d-none d-xl-inline-block"
          >
            <i className="bi bi-whatsapp"></i> Contact Us
          </a>
        </nav>
      </div>
    </header>
  );
};

export default Header;
